import { StoreAction, XmAction } from 'store/actions';
import { PastDue, RetryPaymentData, RetryPaymentResult } from 'store/past-due/models';

export function pastDueReducer(state: PastDue, action: XmAction<PastDue>): PastDue {
    switch (action.type) {
        case StoreAction.GET_PAST_DUE:
        case StoreAction.CLEAR_PAST_DUE:
            return action.payload;
        default:
            return state;
    }
}

export function retryPaymentDataReducer(state: RetryPaymentData, action: XmAction<RetryPaymentData>): RetryPaymentData {
    switch (action.type) {
        case StoreAction.SAVE_RETRY_PAYMENT_DATA:
        case StoreAction.GET_RETRY_PAYMENT_DATA:
        case StoreAction.CLEAR_RETRY_PAYMENT_DATA:
            return action.payload;
        default:
            return state;
    }
}

export function retryPaymentResultReducer(state: RetryPaymentResult, action: XmAction<RetryPaymentResult>): RetryPaymentResult {
    switch (action.type) {
        case StoreAction.POST_RETRY_PAYMENT:
            return action.payload;
        case StoreAction.CLEAR_RETRY_PAYMENT_RESULT:
            return undefined;
        default:
            return state;
    }
}
